<app-add-edit-reward [previousPage]="previousPage" [product]="product"></app-add-edit-reward>
